/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiLocationVelocityTypeFromJSON, ApiLocationVelocityTypeToJSON, } from './ApiLocationVelocityType';
export function ApiLocationVelocityPayloadFromJSON(json) {
    return ApiLocationVelocityPayloadFromJSONTyped(json, false);
}
export function ApiLocationVelocityPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'velocityLimit': !exists(json, 'velocityLimit') ? undefined : json['velocityLimit'],
        'velocityRender': !exists(json, 'velocityRender') ? undefined : json['velocityRender'],
        'velocityType': !exists(json, 'velocityType') ? undefined : ApiLocationVelocityTypeFromJSON(json['velocityType']),
    };
}
export function ApiLocationVelocityPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'velocityLimit': value.velocityLimit,
        'velocityRender': value.velocityRender,
        'velocityType': ApiLocationVelocityTypeToJSON(value.velocityType),
    };
}
